import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from 'auth';
import { Observable } from 'rxjs';

import { EnvService } from 'frontend-environment';

/**
 * navItems typically have checkers but we have a scenario where we need to hit an endpoint for this
 * @returns
 */
export function navItemChecker$(): Observable<boolean> {
  const authService = inject(AuthService);
  return authService.isInternalAdmin$;
}

@Injectable()
export class ApplicationManagerGuard implements CanActivate {
  private authService = inject(AuthService);
  private env = inject(
    EnvService<{
      APPLICATION_MANAGER_URL: string;
    }>,
  );

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isInternalAdmin$;
  }
}
